import React, { useCallback, useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import * as yup from "yup";
import { yupResolver } from "@hookform/resolvers/yup";
import {
  changePasswordDetails,
  getSecurityQuestions,
  saveProfileDetails,
} from "../../../Redux/actions";
import ModelContainer from "../../Components/ModelContainer";
import UserInterface from "../../Components/InnerLayout/UserInterface";
import { useForm } from "react-hook-form";
import { removeUnderScore } from "../../../helpers";

const schema = yup
  .object({
    security_question: yup.string().required(),
    security_answer: yup.string().required().max(255),
  })
  .required();

const changePassSchema = yup
  .object({
    old_password: yup.string().required(),
    password: yup.string().required(),
    password_confirmation: yup.string().required(),
  })
  .required();

const Profile = (params) => {
  const history = useHistory();
  const dispatch = useDispatch();
  const { user_details } = useSelector((state) => state.authReducer);
  const { security_questions } = useSelector((state) => state.accountReducer);
  const [addressModal, setAddressModal] = useState(false);
  const [profileForm, setProfileForm] = useState({
    security_question: user_details?.user?.security_question ?? "",
    security_answer: user_details?.user?.security_answer ?? "",
  });
  const [changePassForm, setChangePassForm] = useState({
    old_password: "",
    password: "",
    password_confirmation: "",
  });

  const {
    register,
    formState: { errors },
    handleSubmit,
    control,
  } = useForm({
    resolver: yupResolver(schema),
  });
  const {
    register: changePassRegister,
    formState: { errors: changePassErrors },
    handleSubmit: changePassHandleSubmit,
    control: changePassControl,
  } = useForm({
    resolver: yupResolver(changePassSchema),
  });

  useEffect(() => {
    dispatch(getSecurityQuestions());
  }, []);

  const getUserRoles = () => {
    let res = null;
    if (user_details?.user_roles && user_details?.user_roles.length > 0) {
      res = user_details?.user_roles.map((role) => {
        return (
          <tr>
            <td>{role?.merchant?.account_name ?? "N/A"}</td>
            <td>{role?.group?.name ?? "N/A"}</td>
          </tr>
        );
      });
    }
    return res;
  };

  const getSecurityOptions = () => {
    let res = null;
    console.log("security_questions", security_questions);
    if (security_questions && security_questions.length > 0) {
      res = security_questions.map((question, inx) => {
        return (
          <option value={question?.name} key={question?.id}>
            {question?.name}
          </option>
        );
      });
    }
    return res;
  };
  const closeModal = useCallback(
    (value) => {
      setAddressModal(value);
    },
    [addressModal]
  );

  const changeProfileInputHandler = (input, val) => {
    setProfileForm((prevState) => ({ ...prevState, [input]: val }));
  };

  const changePassInputHandler = (input, val) => {
    setChangePassForm((prevState) => ({ ...prevState, [input]: val }));
  };

  const onProfileSubmit = (data) => {
    dispatch(saveProfileDetails(data));
  };

  const onChangePassSubmit = (data) => {
    closeModal(false);
    dispatch(changePasswordDetails(data));
  };

  return (
    <UserInterface>
      <div className="bg_white_full">
        <div className="container-fluid d-flex justify-content-center">
          <div className="inner_content col-11">
            <div className="main-top-bar statistic clearfix">
              <div className="current_page py-4">
                <span>
                  <i className="img_icon_setting"></i> Settings
                  <i className="icon-arrow-fo"></i>
                  <span>Profile</span>
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="container-fluid d-flex justify-content-center">
        <div className="inner_content col-11">
          <div className="widgets_area">
            <div className="row">
              <form
                id="UserProfileForm"
                onSubmit={handleSubmit(onProfileSubmit)}
              >
                <div className="shadowclass">
                  <div className="row mx-0">
                    <div className="col-12 px-md-4 px-0">
                      <div className="counts">
                        <h4 className="event-alert ">Profile</h4>
                      </div>
                    </div>
                    <div className="d-flex other_input justify-content-start flex-wrap">
                      <div className="col-lg-5 col-12">
                        <ul className="ingredient-info edit-shift px-0">
                          <li>
                            <label className="">Role Title </label>
                            <div className="input-group col-md-7">
                              {user_details?.empObj?.role_title ?? "N/A"}
                            </div>
                          </li>
                          <li>
                            <label className="">First Name</label>
                            <div className="input-group col-md-7">
                              <div className="input-group col-md-7">
                                {user_details?.user?.first_name ?? "N/A"}
                              </div>
                            </div>
                          </li>
                          <li>
                            <label className="">Last Name</label>
                            <div className="input-group col-md-7">
                              <div className="input-group col-md-7">
                                {user_details?.user?.last_name ?? "N/A"}
                              </div>
                            </div>
                          </li>
                          <li>
                            <label className="">Email </label>
                            <div className="input-group  col-md-7">
                              <div className="input-group col-md-7">
                                {user_details?.user?.email ?? "N/A"}
                              </div>
                            </div>
                          </li>
                          <li>
                            <label className="">Security Question </label>
                            <div className="input-group select-div">
                              <select
                                {...register("security_question")}
                                value={profileForm?.security_question}
                                onChange={(e) => {
                                  changeProfileInputHandler(
                                    "security_question",
                                    e?.target?.value
                                  );
                                }}
                              >
                                <option value="">
                                  Select Security Question
                                </option>
                                {getSecurityOptions()}
                              </select>
                              {errors?.security_question && (
                                <label className="error">
                                  {removeUnderScore(
                                    errors.security_question?.message
                                  )}
                                </label>
                              )}
                            </div>
                          </li>
                          <li>
                            <label className="">Answer </label>
                            <div className="input-group col-md-7">
                              <input
                                {...register("security_answer")}
                                autoComplete="new-password"
                                value={profileForm?.security_answer}
                                onChange={(e) => {
                                  changeProfileInputHandler(
                                    "security_answer",
                                    e?.target?.value
                                  );
                                }}
                                placeholder="Security Answer"
                                className="input-txt"
                                type="password"
                              />
                              {errors?.security_answer && (
                                <label className="error">
                                  {removeUnderScore(
                                    errors.security_answer?.message
                                  )}
                                </label>
                              )}
                            </div>
                          </li>
                        </ul>
                      </div>

                      <div className="col-lg-4 col-12">
                        <div className="inner-space screen-scroll mCS_destroyed">
                          <table
                            width="100%"
                            cellSpacing="0"
                            cellPadding="0"
                            style={{ marginBottom: "0 !important" }}
                            className="checklist-table remove-space inventory_table"
                          >
                            <thead>
                              <tr>
                                <th>Account </th>
                                <th>Permission Group</th>
                              </tr>
                            </thead>
                            <tbody>{getUserRoles()}</tbody>
                          </table>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="clearfix"> </div>

                <div className="row mx-0 my-4 justify-content-start">
                  <div className="btns px-0">
                    <button
                      type="button"
                      className="resetPassowrd"
                      onClick={() => closeModal(true)}
                    >
                      Reset Password
                    </button>
                    <button type="Submit">Save</button>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
      <ModelContainer
        open={addressModal}
        closeModal={closeModal}
        submitModal={changePassHandleSubmit(onChangePassSubmit)}
        is_loading={false}
      >
        <div
          id="dialog-form-reset-password"
          title="Reset Password"
          className="add-popup"
        >
          <form id="UserPasswordProfileForm">
            <fieldset className="">
              {console.log("changePassErrors", changePassErrors)}
              <ul className="form-list label-group p-0">
                <li>
                  Old Password
                  <div className="input-group mb10">
                    <input
                      {...changePassRegister("old_password")}
                      autoComplete="new-password"
                      className="required"
                      type="password"
                      id="UserOldPassword"
                      value={changePassForm?.old_password}
                      onChange={(e) => {
                        changePassInputHandler(
                          "old_password",
                          e?.target?.value
                        );
                      }}
                    />
                    {changePassErrors?.old_password && (
                      <label className="error">
                        {removeUnderScore(
                          changePassErrors.old_password?.message
                        )}
                      </label>
                    )}
                  </div>
                </li>
                <li>
                  New Password
                  <div className="input-group mb10">
                    <input
                      {...changePassRegister("password")}
                      autoComplete="new-password"
                      className="required"
                      type="password"
                      id="UserNewPassword"
                      value={changePassForm?.password}
                      onChange={(e) => {
                        changePassInputHandler("password", e?.target?.value);
                      }}
                    />
                    {changePassErrors?.password && (
                      <label className="error">
                        {removeUnderScore(changePassErrors.password?.message)}
                      </label>
                    )}
                  </div>
                </li>
                <li>
                  Confirm Password
                  <div className="input-group mb10">
                    <input
                      {...changePassRegister("password_confirmation")}
                      autoComplete="new-password"
                      className="required"
                      type="password"
                      id="UserConfirmPassword"
                      value={changePassForm?.password_confirmation}
                      onChange={(e) => {
                        changePassInputHandler(
                          "password_confirmation",
                          e?.target?.value
                        );
                      }}
                    />
                    {changePassErrors?.password_confirmation && (
                      <label className="error">
                        {removeUnderScore(
                          changePassErrors.password_confirmation?.message
                        )}
                      </label>
                    )}
                  </div>
                </li>
              </ul>
            </fieldset>
          </form>
        </div>
      </ModelContainer>
    </UserInterface>
  );
};
export default Profile;
